import { gql } from 'apollo-angular';

export const getCountryDetailsQuery = gql`
  query GetCountryDetails($label: String!) {
    getCountryDetails(label: $label) {
      currencies {
        id
        value
      }
      time_zones {
        id
        zone
        utc_offset
      }
    }
  }
`;
